import React, { cloneElement, FC, isValidElement, ReactElement } from 'react';

const valueIsDefined = <T,>(value: T): value is Exclude<T, undefined> =>
  typeof value !== 'undefined';

const Nested: FC<{
  elements: (ReactElement | undefined)[];
  children?: React.ReactNode;
}> = ({ elements, children }) => {
  const nested = elements
    .filter(valueIsDefined)
    .reduceRight(
      (acc, element) => cloneElement(element, undefined, acc),
      children,
    );
  return isValidElement(nested) ? nested : <>{nested}</>;
};

export default Nested;
